import { combineReducers } from 'redux';

import ids from './ids';
import isLoading from './isLoading';
import page from './page';

/**
 * @typedef {{
 *   ids: string[],
 *   page: import('modules/global/generic.types').Page,
 *   isLoading: boolean,
 * }} AuditModelDashboardAvailableUIReducer
 */

export default combineReducers({
  ids,
  page,
  isLoading,
});
